export default __webpack_public_path__ + "static/precision_machining-725399ed871568f63ba8374eeafe71cd.jpg";